import { BaseControl } from "../base-control";

class FileControlCtrl extends BaseControl {
  emptyModel = {display: {}, value: {}};
  
  readOnlyHtml = null;
  fileUrl = null;
  copy = null;
  modal = null;
  uibModal = null;
  constructor(BaseControlService, $scope, $uibModal, $element, $sce) {
    'ngInject';
    super(BaseControlService, $scope);
    Object.assign(this, { $uibModal, $element, $sce });
  }

  async initializeControlData(){
    await super.initializeControlData();
    this.fileUrl = await this.buildURL();
    this.setReadOnlyHtml();
  }

  setReadOnlyHtml() {
    const linkText = this.token.options?.showLabelLink ? this.label : this.model?.value?.filename;
    const html = this.fileUrl && this.model?.value
      ? `<a href="#" onclick="window.open('${this.fileUrl}', '_blank'); return false;">${linkText}</a>`
      : '';
    this.readOnlyHtml = this.$sce.trustAsHtml(html);
  }
  
  isSame(newVal, oldVal={}) {
    return angular.equals(newVal, oldVal);
  }
  
  onFileRead(file) {
    this.copy = angular.copy(this.model);
    const body = file.body || '';
    this.model.value = {
      filename: file.filename || '',
      body: file.ignoreEncoding ? body : btoa(body),
      ignoreEncoding: true,
      tokenId: this.token.id
    };
  }
  
  reset() {
    if (this.copy) this.model = angular.copy(this.copy);
  }
  
  modalKeyDown(event) {
    if (!this.modal) return null;

    switch(event?.key) {
      case 'Escape':
        this.reset();
        return this.cancelModal();
      case 'Tab':
        return this.cancelModal();
      default:
        return;
    }
  }
  
  cancelModal(nextAction) { 
    this.modal.dismiss(nextAction);
    this.$timeout(() => this.modal = null);
  }
  
  doneModal() { 
    this.modal.close();
    this.$timeout(() => this.modal = null);
  }

  clearModal() { 
    this.copy = angular.copy(this.model);
    this.clearModel();
  }

  openModal() {
    if (this.modal) return null;

    const uibModal = { scope: this.$scope, size: "lg control-modal", backdrop: false };
    uibModal.template =
      `<file-upload-modal
          model="$ctrl.model.value"
          field-id="$ctrl.fieldId"
          modal-title="$ctrl.label"
          on-file-read="$ctrl.onFileRead(file, customId)"
          id="$ctrl.id"
          file="$ctrl.file"
          file-url="$ctrl.fileUrl"
          provider-file="$ctrl.model.value"
          cancel-modal="$ctrl.cancelModal()"
          done-modal="$ctrl.doneModal()"
          clear-modal="$ctrl.clearModal()"
          key-down="$ctrl.modalKeyDown(event)">
        </file-upload-modal>`;
    
    this.modal = this.dom.openModal(this.$uibModal, uibModal, { triggerElement: this.$element });
    
    this.modal.result.then(
      closed => this.copy = null,
      canceled => this.reset()
    );
  }
  
  async buildURL() {
    const { url } = (this.model?.value || {});
    if (!url) return null;

    return await this.ts.getTemplateAttachmentUrl(url);
  }
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/file-control/file-control.component.html",
  controller: FileControlCtrl
};